import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "../index.scss";
import QueryProvider from "./QueryProvider";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </React.StrictMode>
);
